import ActionTypeZona from "../ActionTypeZona";

export default class CargaDeZonasBuscados extends ActionTypeZona {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.flag.procesandoComandoBuscarAll = false;
        nuevoEstado.output.domain.resultSet = this.payload;
        nuevoEstado.flag.sensorMostrarFinalTabla=!estado.flag.sensorMostrarFinalTabla;
        return nuevoEstado;
    }
}
